module.exports = __webpack_public_path__ + "static/media/CRUD REACT.2c2c3547.png";